// @flow

import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import Path from 'routes/path'
import { message as antdMessage } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ReservationModel from 'frontend_core/dist/model/Reservation'
import { fileReadFromInputFile } from 'frontend_core/dist/helpers/image'

import { isMobile } from 'common/screen'
import { setUIState, containerIds } from 'redux/modules/ui'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'
import MessageConnector from 'lib/message-connector'

import ReservationSidebarContainer from 'containers/organisms/ReservationSidebar'
import MainTemplate from 'components/templates/MainTemplate'
import MainContentsWithSidebarInbox from 'components/templates/MainContentsWithSidebarInbox'
import MessagesForm from 'components/organisms/ReservationMessagesForm'
import getReservationMessagesForm from 'components/organisms/ReservationMessagesForm/presenter'
import LoadingView from 'components/atoms/LoadingView'
import ConfirmSendAttachmentModal from 'components/organisms/ReservationConfirmSendAttachmentModal'

import graphql from './graphql'
import { accountLoginUrl } from 'frontend_core/dist/helpers/url'

export type PropTypes = {
  match: {
    params: {
      ownerName: string,
    },
    path: string,
  },
  location: {
    pathname: string,
  },
  history: {
    replace: Function,
    push: Function,
  },
  ui: {
    loading: boolean,
    messagesFetching: boolean,
    messageSending: boolean,
    message: string,
    isShowContentsSp?: boolean,
  },
  actions: {
    setUIState: Function,
  },
  reservationDetail: ReservationDetailState,
}

function isImageFileName(filename: string): boolean {
  return Boolean(
    (filename || '').toLowerCase().match(/(\.jpg|\.png|\.gif|\.jpeg|\.bmp)$/i),
  )
}

class ReservationDetailPageContainer extends Component<PropTypes, *, *> {
  static async getInitialProps({ req, res, params, config, isLogin }) {
    if (!isLogin)
      return { redirect: { to: accountLoginUrl(config), status: 302 } }
    return
  }

  constructor(props: PropTypes) {
    super(props)

    this.onReachedTop = this.onReachedTop.bind(this)
    this.onRefTopMessageBaloon = this.onRefTopMessageBaloon.bind(this)
    this.handleChangeUI = this.handleChangeUI.bind(this)
    this.onClickSendMessage = this.onClickSendMessage.bind(this)
    this.onClickFile = this.onClickFile.bind(this)
    this.onRefInputFile = this.onRefInputFile.bind(this)
    this.onChangeFile = this.onChangeFile.bind(this)

    this.exeSendFile = this.exeSendFile.bind(this)
    this.notSendFile = this.notSendFile.bind(this)
  }

  componentDidMount() {
    const { actions, reservationDetail, match, config, data } = this.props
    const { detail, messages } = reservationDetail

    // 初期データ取得
    actions.fetchReservationDetail({
      userId: data.viewer.id,
      reservationId: match.params.reservationId,
    })
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      // モバイル時はメッセージパスならメッセージを表示、PCは考慮しない
      isShowContentsSp: isMobile()
        ? Path.reservationMessage() === match.path
        : undefined,
      message: '',
    })
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { actions, reservationDetail, match, config, data, ui } = this.props
    const { reservationDetail: prevReservationDetail, ui: prevUi } = prevProps

    const isMobileDevice = isMobile()
    // 初回ロードで一番下までスクロール
    if (
      reservationDetail.messages.length > 0 &&
      prevReservationDetail.messages.length === 0
    ) {
      // PCは必ず、モバイルはメッセージタブが開いている場合のみ
      if (
        window &&
        document.body &&
        (!isMobileDevice || (isMobileDevice && ui.isShowContentsSp))
      ) {
        window.scrollTo(0, document.body.scrollHeight || 0)
      }
    }
    // SP時に変化があって、詳細なら上に、メッセージなら下にスクロール
    if (isMobileDevice && prevUi.isShowContentsSp !== ui.isShowContentsSp) {
      window.scrollTo(
        0,
        !prevUi.isShowContentsSp && ui.isShowContentsSp
          ? document.body.scrollHeight || 0
          : 0,
      )
    }
    // 予約情報が変わったらその予約に対するPusherをセット
    if (prevReservationDetail.detail.id !== reservationDetail.detail.id) {
      let subscribeReservation = reservationDetail.detail
      this.connector = new MessageConnector(
        config.SPM_PUSHER_KEY,
        config.ENV === 'development',
      )
      // Pusherのsubscribe
      this.connector.subscribe(subscribeReservation, 'new-message', message => {
        actions.addNewMessage(message)
        if (!isMobileDevice || (isMobileDevice && ui.isShowContentsSp)) {
          window.scrollTo(0, document.body.scrollHeight || 0)
        }
      })
    }

    // エラー系の表示
    if (
      reservationDetail.failedFetchReservationDetail !== null &&
      prevReservationDetail.failedFetchReservationDetail === null
    ) {
      antdMessage.warning(reservationDetail.failedFetchReservationDetail)
    }
    if (
      reservationDetail.failedSendMessage !== null &&
      prevReservationDetail.failedSendMessage === null
    ) {
      antdMessage.warning(reservationDetail.failedSendMessage)
    }
    if (
      reservationDetail.failedFetchMessages !== null &&
      prevReservationDetail.failedFetchMessages === null
    ) {
      antdMessage.warning(reservationDetail.failedFetchMessages)
    }
  }

  componentWillUnmount() {
    // Pusherの後処理
    if (this.connector) {
      this.connector.unsubscribe()
    }
  }

  onRefTopMessageBaloon: Function
  onRefTopMessageBaloon(ref) {
    this.topMessageBaloonComponent = ref
  }

  // 無限スクロール
  onReachedTop: Function
  onReachedTop() {
    const { reservationDetail, match, ui, actions } = this.props
    if (
      !ui.isLoading &&
      !ui.messagesFetching &&
      reservationDetail.hasMoreData
    ) {
      actions.fetchMessages({
        reservationId: match.params.reservationId,
        nextPage: reservationDetail.nextMessagePage,
      })
    }
  }

  // テキストメッセージ送信
  onClickSendMessage: Function
  onClickSendMessage() {
    const { ui, actions, match, data } = this.props

    if (ui.message) {
      actions.sendMessage({
        userId: data.viewer.id,
        reservationId: match.params.reservationId,
        text: ui.message,
      })
    }
  }

  // ファイル選択
  onClickFile: Function
  onClickFile(e) {
    e.preventDefault()
    if (this.inputFile) {
      this.inputFile.click()
    }
  }

  onRefInputFile: Function
  onRefInputFile(ref) {
    this.inputFile = ref
  }

  // ファイルが選択された時
  onChangeFile: Function
  onChangeFile(file) {
    const { actions } = this.props
    if (file) {
      fileReadFromInputFile(file, fileUri => {
        // ファイル送信確認modal表示のため
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          trySendFile: file,
          sendFileUri: fileUri,
        })
      })
    }
  }

  notSendFile: Function
  notSendFile() {
    const { actions } = this.props
    if (this.inputFile) {
      this.inputFile.value = null
    }
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      trySendFile: null,
      sendFileUri: null,
    })
  }

  // ファイル送信
  exeSendFile: Function
  exeSendFile() {
    const { ui, actions, match, data } = this.props

    actions.sendMessage({
      userId: data.viewer.id,
      reservationId: match.params.reservationId,
      text: ui.message,
      fileUri: ui.trySendFile,
    })
  }

  // UI変更汎用処理
  handleChangeUI: Function
  handleChangeUI(name: string, value: any) {
    const { actions } = this.props
    const state = {}
    state[name] = value
    actions.setUIState(containerIds.RESERVATION_DETAIL, state)
  }

  connector: MessageConnector
  topMessageBaloonComponent: any
  inputFile: any

  render() {
    const { location, match, reservationDetail, ui } = this.props
    const { detail, messages, id } = reservationDetail

    // 変更リクエストがあれば強制遷移する
    // 変更リクエスト画面からSPAで戻ってきているなら強制遷移しない
    if (
      ReservationModel.hasChangeRequestFromOwner(detail) &&
      !ui.backedFromChangeRequest
    ) {
      return (
        <Redirect to={Path.reservationChangeHost(match.params.reservationId)} />
      )
    }

    return (
      <MainTemplate
        title={i18n.t('server.www.reservationDetail.title', {
          id: detail.id || '-',
        })}
        isFixedHeader
        hideMustHeader
        hasFooter={false}
        {...this.props}
      >
        <MainContentsWithSidebarInbox
          isShowContentsSp={ui.isShowContentsSp}
          isShowFixedTabSp={true}
          onClickDetailTab={() =>
            this.handleChangeUI('isShowContentsSp', false)
          }
          onClickMessageTab={() =>
            this.handleChangeUI('isShowContentsSp', true)
          }
          sidebarInbox={<ReservationSidebarContainer />}
        >
          {detail.id && (
            <MessagesForm
              {...getReservationMessagesForm(
                reservationDetail,
                ui,
                this.onReachedTop,
                this.onRefTopMessageBaloon,
                this.handleChangeUI,
                this.onClickSendMessage,
                this.onClickFile,
                this.onRefInputFile,
                this.onChangeFile,
              )}
            />
          )}
        </MainContentsWithSidebarInbox>
        {ui.trySendFile && (
          <ConfirmSendAttachmentModal
            isActive={ui.trySendFile}
            onClickClose={this.notSendFile}
            onClickNegative={this.notSendFile}
            onClickPositive={ui.messageSending ? null : this.exeSendFile}
            src={ui.sendFileUri}
            isAttachment={!isImageFileName((ui.trySendFile || {}).name)}
            filename={(ui.trySendFile || {}).name}
          />
        )}
        {ui.isLoading && <LoadingView />}
      </MainTemplate>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    reservationDetail: state.reservationDetail,
    config: state.config,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...ReservationDetailActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const WrappedContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(ReservationDetailPageContainer)),
)

export default WrappedContainer



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationDetailPage/index.jsx